import React from 'react';
import { Card, Table } from 'react-bootstrap';
import './TopBuildingsByValueTable.css';

const CONTRACT_LABELS = {
  'hvac-maintenance': 'HVAC Maintenance',
  'mechanical-room': 'Mechanical Room',
  'dryer-vent': 'Dryer Vents',
  'stack-cleaning': 'Stack Cleaning',
};

function TopBuildingsByValueTable({ buildingsData }) {
  // Sort and take top 5 by contract value
  const topBuildings = [...(buildingsData || [])]
    .sort((a, b) => (Number(b.contractValue) || 0) - (Number(a.contractValue) || 0))
    .slice(0, 5);

  // Summary stats
  const totalValue = topBuildings.reduce((sum, b) => sum + (Number(b.contractValue) || 0), 0);

  return (
    <Card className="contracts-table-card">
      <Card.Body>
        <h5 className="table-title">Top Buildings by Contract Value</h5>
        <div style={{ overflowX: 'auto' }}>
          <Table hover responsive className="mb-0">
            <thead>
              <tr>
                <th>Building Name</th>
                <th>Contracts</th>
                <th>Contract Value</th>
              </tr>
            </thead>
            <tbody>
              {topBuildings.length === 0 ? (
                <tr>
                  <td colSpan={3} style={{ textAlign: 'center', padding: '2rem' }}>
                    No buildings found.
                  </td>
                </tr>
              ) : (
                topBuildings.map((b, idx) => (
                  <tr key={b.buildingId || idx}>
                    <td>{b.name || '-'}</td>
                    <td>
                      {Array.isArray(b.contracts) && b.contracts.length > 0
                        ? b.contracts.map((c, i) => (
                            <span key={c} style={{
                              display: 'inline-block',
                              background: '#f1f3f7',
                              color: '#333',
                              borderRadius: '12px',
                              padding: '2px 10px',
                              marginRight: 6,
                              marginBottom: 2,
                              fontSize: '0.95em',
                              fontWeight: 500,
                            }}>
                              {CONTRACT_LABELS[c] || c}
                            </span>
                          ))
                        : <span style={{ color: '#aaa' }}>None</span>}
                    </td>
                    <td style={{ fontWeight: 600 }}>
                      {b.contractValue ? `$${Number(b.contractValue).toLocaleString()}` : '-'}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
        {/* Summary Stats */}
        <div className="table-summary">
          <div className="summary-item">
            <span className="summary-label">Total Value (Top 5):</span>
            <span className="summary-value">${totalValue.toLocaleString()}</span>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default TopBuildingsByValueTable; 